import React, { useState, useEffect, useRef } from "react";
import "./tableStyle.css";
import { reportsApi, exportMonthlyReportExcel } from "../../Services/Services";
import { Col, Input, Button, Select, Form, message } from "antd";
import { useReactToPrint } from "react-to-print";
import * as XLSX from "xlsx"; // Import xlsx library
import { EditOutlined } from "@ant-design/icons";
import { FaFilePdf, FaFileExcel } from "react-icons/fa";
import InfiniteScroll from "react-infinite-scroll-component";
import { debounce } from "../util.js";
import { Link } from "react-router-dom";

const { Option } = Select;
export default function MonthlyReport({ onChange }) {
  const [deliveryOrder, setDeliveryOrder] = useState([]);
  // const [orderList, setOrderList] = useState([]);
  const [form] = Form.useForm();
  const [searchTruckOwner, setSearchTruckOwner] = useState("");
  const [searchCheckNo, setSearchCheckNo] = useState("");
  const [searchCheckDate, setSearchCheckDate] = useState("");
  const [searchDoNo, setSearchDoNo] = useState("");
  const [page, setPage] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  const [selectedMonth, setSelectedMonth] = useState(1);
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const [exporting, setExporting] = useState(false);
  const limit = 50;

  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  useEffect(() => {
    setPage(0);
    setHasMore(true);
    fetchData(0, selectedMonth, selectedYear);
  }, [selectedMonth, selectedYear]);

  const fetchData = async (
    offset,
    month,
    year,
    truckOwner = "",
    checkNo = "",
    checkDate = "",
    doNo = ""
  ) => {
    if (!month) return;

    const response = await reportsApi({
      report_name: "monthly_report",
      com_name: localStorage.getItem("com_name"),
      month,
      year,
      truck_owner_name: truckOwner,
      check_no: checkNo,
      check_date: checkDate,
      do_no: doNo,
      limit,
      offset,
    });

    if (response) {
      const newData = Array.isArray(response.results)
        ? response.results
        : Array.isArray(response)
        ? response
        : [];

      if (offset === 0) {
        setDeliveryOrder(newData);
      } else {
        setDeliveryOrder((prev) => [...prev, ...newData]);
      }
      if (!response.next) {
        setHasMore(false);
      }
    }
  };

  const fetchMoreData = () => {
    const newOffset = page + limit;
    setPage(newOffset);
    fetchData(
      newOffset,
      selectedMonth,
      selectedYear,
      searchTruckOwner,
      searchCheckNo,
      searchCheckDate,
      searchDoNo
    );
  };

  const debouncedSearch = useRef(
    debounce((party, checkNo, checkDate, doNo) => {
      setPage(0);
      setHasMore(true);
      fetchData(
        0,
        selectedMonth,
        selectedYear,
        party,
        checkNo,
        checkDate,
        doNo
      );
    }, 1000)
  ).current;

  const handleExportToExcel = async () => {
    try {
      setExporting(true);
      message.loading({ content: "Generating Excel file...", key: "export" });

      const params = {
        com_name: localStorage.getItem("com_name"),
        month: selectedMonth,
        year: selectedYear,
        truck_owner_name: searchTruckOwner || "",
        check_no: searchCheckNo || "",
        check_date: searchCheckDate || "",
        do_no: searchDoNo || "",
        user_type: localStorage.getItem("user_type"),
        lifter_id: localStorage.getItem("user_id"),
      };

      const response = await exportMonthlyReportExcel(params);

      if (!response.success) {
        throw new Error(response.error || "Failed to export Excel file");
      }

      // Create download link
      const url = window.URL.createObjectURL(response.data);
      const link = document.createElement("a");
      link.href = url;

      // Generate filename
      const monthNames = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];
      const monthName = monthNames[selectedMonth - 1];
      const timestamp = new Date()
        .toISOString()
        .replace(/[:.]/g, "-")
        .slice(0, -5);

      let filename = `MonthlyFreightReport_${monthName}_${selectedYear}_${timestamp}.xlsx`;

      // Extract filename from headers if available
      const contentDisposition = response.headers?.["content-disposition"];
      if (contentDisposition) {
        const filenameMatch = contentDisposition.match(
          /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
        );
        if (filenameMatch && filenameMatch[1]) {
          filename = filenameMatch[1].replace(/['"]/g, "");
        }
      }

      link.download = filename;

      // Trigger download
      document.body.appendChild(link);
      link.click();

      // Cleanup
      link.remove();
      window.URL.revokeObjectURL(url);

      message.success({
        content: "Excel file downloaded successfully!",
        key: "export",
        duration: 2,
      });
    } catch (error) {
      console.error("Error exporting to Excel:", error);
      message.error({
        content:
          error.message || "Failed to export Excel file. Please try again.",
        key: "export",
        duration: 3,
      });
    } finally {
      setExporting(false);
    }
  };

  const formateDate = (date) => {
    if (date) {
      const [year, month, day] = date.split("-");
      const formattedDate = `${day}-${month}-${year}`;
      return formattedDate;
    }
  };
  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: currentYear - 2022 }, (_, i) => 2023 + i);

  return (
    <div>
      <Form form={form} layout="vertical">
        <div className=" grid grid-cols-1 sm:grid sm:grid-cols-7 sm:gap-2 m-auto px-5 sm:w-[70%]  md:w-[100%]">
          <Col>
            <label>
              <b>Select Year</b>
            </label>
            <br />
            <Select
              showSearch
              style={{ width: "95%", marginLeft: "2%", marginRight: "2%" }}
              placeholder="Select Year"
              value={selectedYear} // <-- Set current year as selected
              onChange={(value) => setSelectedYear(value)} // <-- Allow user to change
            >
              {years.map((year) => (
                <Option value={year}>{year}</Option>
              ))}
            </Select>
          </Col>

          <Col>
            <label>
              <b>Select Month</b>
            </label>
            <br />

            <Select
              value={selectedMonth}
              onChange={(month) => {
                setSelectedMonth(month);
                setPage(0);
                setHasMore(true);
                setDeliveryOrder([]);
              }}
              style={{ width: "95%", marginLeft: "2%", marginRight: "2%" }}
            >
              <Option value={1}>January</Option>
              <Option value={2}>February</Option>
              <Option value={3}>March</Option>
              <Option value={4}>April</Option>
              <Option value={5}>May</Option>
              <Option value={6}>June</Option>
              <Option value={7}>July</Option>
              <Option value={8}>August</Option>
              <Option value={9}>September</Option>
              <Option value={10}>October</Option>
              <Option value={11}>November</Option>
              <Option value={12}>December</Option>
            </Select>
          </Col>
          <Col>
            <label>
              <b>Search By Do No.</b>
            </label>
            <br />
            <Form.Item name="do_no">
              <Input
                placeholder="Search by DO No."
                value={searchDoNo}
                onChange={(e) => {
                  const value = e.target.value;
                  setSearchDoNo(value);
                  debouncedSearch(
                    searchTruckOwner,
                    searchCheckNo,
                    searchCheckDate,
                    value
                  );
                }}
              />
            </Form.Item>
          </Col>
          <Col>
            <label>
              <b>Truck Owner Name</b>
            </label>
            <br />
            <Form.Item name="truck_owner_name">
              <Input
                placeholder="Search by Truck Owner Name"
                value={searchTruckOwner}
                onChange={(e) => {
                  const value = e.target.value;
                  setSearchTruckOwner(value);
                  debouncedSearch(value, searchCheckNo, searchCheckDate);
                }}
              />
            </Form.Item>
          </Col>

          <Col>
            <label>
              <b>Search By Check No</b>
            </label>
            <br />
            <Form.Item name="check_no">
              <Input
                placeholder="Search by Check No"
                value={searchCheckNo}
                onChange={(e) => {
                  const value = e.target.value;
                  setSearchCheckNo(value);
                  debouncedSearch(searchTruckOwner, value, searchCheckDate);
                }}
              />
            </Form.Item>
          </Col>
          <Col>
            <label>
              <b>Search By Check Date</b>
            </label>
            <br />
            <Form.Item name="check_date">
              <Input
                type="date"
                value={searchCheckDate}
                onChange={(e) => {
                  const value = e.target.value;
                  setSearchCheckDate(value);
                  debouncedSearch(searchTruckOwner, searchCheckNo, value);
                }}
              />
            </Form.Item>
          </Col>
          <Col>
            <Button
              style={{
                bottom: "-10px",
                margin: "10px",
                backgroundColor: "black",
                color: "white",
                fontWeight: "600",
              }}
              onClick={handlePrint}
            >
              <FaFilePdf />
            </Button>
            <Button
              loading={exporting}
              disabled={exporting}
              style={{
                bottom: "-10px",
                margin: "10px",
                backgroundColor: "green",
                color: "white",
                fontWeight: "600",
              }}
              onClick={handleExportToExcel}
            >
              <FaFileExcel />
            </Button>
          </Col>
        </div>
      </Form>
      <div
        id="scrollableDiv"
        style={{ maxHeight: "500px", overflow: "auto" }}
        ref={componentRef}
      >
        <table id="my-table" className="w-full">
          <thead className="bg-[#151B54] w-full text-white">
            <tr>
              <th>Sr. No</th>
              <th>O. Id</th>
              <th>Do No</th>
              <th>Truck Owner Name</th>
              <th>Pan No</th>
              <th>Vehicle No</th>
              <th>Dipatch Qty</th>
              <th>Recieved Qty</th>
              <th>Freight Qty</th>
              <th>Sort Qty</th>
              <th>Moisture %</th>
              <th>Actual Qty</th>
              <th>Moisture Deduct Qty</th>
              <th>Moisture Amt</th>
              <th>Moisture Deduct</th>
              <th>Sort Amount</th>
              <th>Freight Rate</th>
              <th>Freight Amt</th>
              <th>Tds %</th>
              <th>Tds Amt</th>
              <th>Advance Amt</th>
              <th>Commision Amt</th>
              <th>Pay Amt</th>
              <th>Dispatch Date</th>
              <th>Received Date</th>
              <th>Check No</th>
              <th>Check Date</th>
              <th>Bank Name</th>
              <th>IFSC Code</th>
              <th>Account No </th>
              <th>Aadhar No</th>
            </tr>
          </thead>
          <tbody>
            {deliveryOrder.map((e, index) => (
              <tr key={e.id}>
                <td>{index + 1}</td>
                <td>{e.id}</td>
                <td><Link to={`/do-view/${e.do_id}`}>
                    <u style={{ fontWeight: "600", color: "blue" }}>
                       {e.do_no}
                    </u>
                  </Link></td>
                <td>{e.truck_owner_name}</td>
                <td>{e.pan_no}</td>
                <td>{e.vehicle_no}</td>
                <td>{e.dispatch_quantity.toFixed(3)}</td>
                <td>{e.received_quantity.toFixed(3)}</td>
                <td>{e.freight_quantity.toFixed(3)}</td>
                <td>{e.sort_quantity}</td>
                <td>{e.moisture_received_per}</td>
                <td>{e.actual_quantity}</td>
                <td>{e.moisture_deduct_quantity}</td>
                <td>{e.moisture_amount}</td>
                <td>{e.moisture_deduct}</td>
                <td>{e.sort_amount}</td>
                <td>{e.freight_rate}</td>
                <td>{e.freight_amount}</td>
                <td>{e.tds_per}</td>
                <td>{e.tds}</td>
                <td>{e.advance}</td>
                <td>{e.commision}</td>
                <td>{e.pay_amount}</td>

                <td>{formateDate(e.date)}</td>
                <td>{formateDate(e.received_date)}</td>
                <td>{e.check_no}</td>
                <td>{formateDate(e.check_date)}</td>

                <td>{e.bank_name}</td>
                <td>{e.ifsc_code}</td>
                <td>{e.account_no}</td>
                <td>{e.aadhar_no}</td>
              </tr>
            ))}
            <tr style={{ backgroundColor: "#e9e9e9" }}>
              <td
                className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base"
                colSpan={6}
              >
                <b>Total</b>
              </td>
              <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                <b>
                  {deliveryOrder
                    .reduce(
                      (accumulator, currentValue) =>
                        accumulator + +currentValue.dispatch_quantity,
                      0
                    )
                    .toFixed(3)}
                </b>
              </td>
              <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                <b>
                  {deliveryOrder
                    .reduce(
                      (accumulator, currentValue) =>
                        accumulator + +currentValue.received_quantity,
                      0
                    )
                    .toFixed(3)}
                </b>
              </td>
              <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                <b>
                  {deliveryOrder
                    .reduce(
                      (accumulator, currentValue) =>
                        accumulator + +currentValue.freight_quantity,
                      0
                    )
                    .toFixed(3)}
                </b>
              </td>
              <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base"></td>

              <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base"></td>
              <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base"></td>

              <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base"></td>
              <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                <b>
                  {deliveryOrder
                    .reduce(
                      (accumulator, currentValue) =>
                        accumulator + +currentValue.moisture_amount,
                      0
                    )
                    .toFixed(2)}
                </b>
              </td>
              <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                <b>
                  {deliveryOrder
                    .reduce(
                      (accumulator, currentValue) =>
                        accumulator + +currentValue.moisture_deduct,
                      0
                    )
                    .toFixed(2)}
                </b>
              </td>
              <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                <b>
                  {deliveryOrder
                    .reduce(
                      (accumulator, currentValue) =>
                        accumulator + +currentValue.sort_amount,
                      0
                    )
                    .toFixed(2)}
                </b>
              </td>

              <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base"></td>
              <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                <b>
                  {deliveryOrder
                    .reduce(
                      (accumulator, currentValue) =>
                        accumulator + +currentValue.freight_amount,
                      0
                    )
                    .toFixed(2)}
                </b>
              </td>
              <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base"></td>
              <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                <b>
                  {deliveryOrder
                    .reduce(
                      (accumulator, currentValue) =>
                        accumulator + +currentValue.tds,
                      0
                    )
                    .toFixed(2)}
                </b>
              </td>
              <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                <b>
                  {deliveryOrder
                    .reduce(
                      (accumulator, currentValue) =>
                        accumulator + +currentValue.advance,
                      0
                    )
                    .toFixed(2)}
                </b>
              </td>
              <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                <b>
                  {deliveryOrder
                    .reduce(
                      (accumulator, currentValue) =>
                        accumulator + +currentValue.commision,
                      0
                    )
                    .toFixed(2)}
                </b>
              </td>
              <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                <b>
                  {deliveryOrder
                    .reduce(
                      (accumulator, currentValue) =>
                        accumulator + +currentValue.pay_amount,
                      0
                    )
                    .toFixed(2)}
                </b>
              </td>
              <td
                className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base"
                colSpan={8}
              ></td>
            </tr>
          </tbody>
        </table>
        <InfiniteScroll
          dataLength={deliveryOrder.length}
          next={fetchMoreData}
          hasMore={hasMore}
          loader={
            deliveryOrder.length > 0 && hasMore ? (
              <div style={{ textAlign: "center", padding: "10px" }}>
                Loading...
              </div>
            ) : null
          }
          scrollableTarget="scrollableDiv"
        />
        {/* </InfiniteScroll> */}
      </div>
    </div>
  );
}
